import { connect } from 'react-redux';

import { selectActiveVenueId, selectRouteParams, selectVenueClasses } from 'selectors/general';

import IntegratedServiceDetail from './IntegratedServiceDetail';

const mapStateToProps = state => {
  const venueId = selectActiveVenueId(state);
  const { itemId } = selectRouteParams(state);
  const classId = itemId ? Number(itemId) : undefined;
  // Name + enabled state come from the class-list rows already in Redux; the
  // page fetches the rest of the detail (description, duration, pricing) itself.
  const venueClass = selectVenueClasses(state, venueId).find(({ classId: id }) => id === classId);

  return {
    venueId,
    classId,
    className: venueClass?.className,
    isClassEnabled: venueClass ? !venueClass.disabled : false,
  };
};

export default connect(mapStateToProps)(IntegratedServiceDetail);
